import {
  formatLetterheadAddress,
  formatLetterheadContacts,
  type LetterheadPrint,
} from "./letterhead-print-math";

/** Formal A4/letter header — plan/43. Name-only when logo/address unset. */
export function DocLetterhead({ letterhead }: { letterhead: LetterheadPrint }) {
  const address = formatLetterheadAddress(letterhead);
  const contacts = formatLetterheadContacts(letterhead);
  const showLegal =
    letterhead.legalName &&
    letterhead.legalName.trim() !== letterhead.tradeName.trim();

  return (
    <header className="mb-3 border-b border-black/25 pb-3 text-left">
      <div className="flex items-start gap-3">
        {letterhead.logoUrl ? (
          <img
            src={letterhead.logoUrl}
            alt=""
            className="h-12 w-auto max-w-[7rem] object-contain object-left"
          />
        ) : null}
        <div className="min-w-0 flex-1">
          <div className="font-sans text-[15px] font-bold leading-tight tracking-tight">
            {letterhead.tradeName}
          </div>
          {showLegal ? (
            <div className="mt-0.5 text-[10px] text-black/70">
              {letterhead.legalName}
            </div>
          ) : null}
          {address.length > 0 ? (
            <div className="mt-1 space-y-0.5 text-[10px] leading-snug text-black/80">
              {address.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </div>
          ) : null}
          {contacts.length > 0 ? (
            <div className="mt-1 text-[10px] text-black/70">
              {contacts.join(" · ")}
            </div>
          ) : null}
          {letterhead.registrationNote ? (
            <div className="mt-1 text-[9px] text-black/60">
              {letterhead.registrationNote}
            </div>
          ) : null}
          {letterhead.permitNote ? (
            <div className="text-[9px] text-black/60">
              {letterhead.permitNote}
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
